<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        :append-to-body="appendToBody"
        :width="width"
        :before-close="beforeClose"
        :show-close="showCloseIcon"
        :close-on-click-modal="false"
        :close-on-press-escape="isPressEscape"
        @open="onOpen"
        @opened="onOpened"
        @close="onClose"
        @closed="onClosed">
      <span slot="title">
        <slot name="title">
          <span class="title">{{ title }}</span>
        </slot>
      </span>
      <slot name="contents" />
      <span v-if="showFooter"
          slot="footer">
        <span class="prepend-footer">
          <slot name="prependFooter" />
        </span>
        <template v-if="showOnlyCloseButton">
          <el-button @click="onCloseButtonClick">
            閉じる
          </el-button>
        </template>
        <template v-else>
          <el-button @click="onCancelButtonClick">
            キャンセル
          </el-button>
          <el-button type="primary"
              :disabled="disableOkButton"
              @click="onOkButtonClick">
            OK
          </el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
.title {
    font-size: 16px;
    font-weight: bold;
    color: #181d62;
}
.prepend-footer {
  float: left;
}

</style>

<script>
export default {
  name: 'BaseDialog',
  inject: ['parentValidator'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: null
    },
    beforeClose: {
      type: Function,
      default: null
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showOnlyCloseButton: {
      type: Boolean,
      default: true
    },
    disableOkButton: {
      type: Boolean,
      default: false
    },
    showCloseIcon: {
      type: Boolean,
      default: true
    },
    isPressEscape: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      closed: false,
      processing: false
    }
  },
  computed: {
  },
  watch: {
    visible (val) {
      if (val) {
        this.dialogVisible = true
        this.closed = false
      } else {
        this.dialogVisible = false
        this.closed = true
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  methods: {
    onOpen () {
      this.$emit('open')
    },
    onOpened () {
      this.$emit('opened')
    },
    onClose () {
      if (this.closed) {
        return
      }
      this.$emit('update:visible', false)
      this.$emit('close')
      this.dialogVisible = false
      this.closed = true
    },
    onClosed () {
      this.$emit('closed')
    },
    onCloseButtonClick () {
      if (this.beforeClose != null) {
        this.beforeClose(this.onClose)
      } else {
        this.onClose()
      }
    },
    onCancelButtonClick () {
      this.$emit('cancel')
    },
    onOkButtonClick () {
      if (this.processing) return
      this.processing = true
      this.$emit('ok')
      setTimeout(() => {
        this.processing = false
      }, 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/BaseDialog.vue